var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"min-width":"320px"}},[_c('v-card-text',[_c('b',[_vm._v("TSIA")]),_vm._v(" - Texas Success Initiative Assessment: The percentage of annual graduates who met the TSI criteria on the TSIA.\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }